import React from 'react';

import { PricingExperimentProvider } from '~shared/hooks/usePricingExperiments';
import { PackageDataProvider } from '~shared/hooks/usePricingExperience';
import { PricingStateProvider } from '~shared/hooks/usePricingState';
import { PricingPageProps } from './types';
import PricingRouter from './router';

const PricingPage = ({ experiments, pricingExperience }: PricingPageProps = {}): JSX.Element => {
  return (
    <PricingExperimentProvider experiments={experiments}>
      <PackageDataProvider pricingExperience={pricingExperience}>
        <PricingStateProvider>
          <PricingRouter />
        </PricingStateProvider>
      </PackageDataProvider>
    </PricingExperimentProvider>
  );
};

export default PricingPage;
